/**
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2018 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe Inc. and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe Inc.
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Inc.
 */

module.exports = {
  AccessRequests: require('./dist/AccessRequests').default,
  Client: require('./dist/Client').default,
  Collaboration: require('./dist/Collaboration').default,
  Collaborators: require('./dist/Collaborators').default,
  Invitations: require('./dist/Invitations').default,
  Resources: require('./dist/Resources').default,
  // NEW DAO DEPENDED CLASSES
  AccessRequestsService: require('./dist/AccessRequestsService').default,
  AuthService: require('./dist/AuthService').default,
  CapabilitiesService: require('./dist/CapabilitiesService').default,
  InvitationService: require('./dist/InvitationService').default,
  ResourcesService: require('./dist/ResourcesService').default,
  ShareContentService: require('./dist/ShareContentService').default,
  ShareService: require('./dist/ShareService').default,
};
